export default __webpack_public_path__ + "static/description-settings-42a0c5e2acc8bc056283d04aca72ab04.jpg";